<script>
    import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
    import range from 'lodash/range';

    const BUFFER_LENGTH = 10;

    export default {
        name: 'PDFData',
        props: {
            url: {
                type: String,
                required: true,
            },
        },
        data() {
            return Object.assign(this.getDefaults(), {
                pdf: undefined,
            });
        },
        computed: {
            pageCount() {
                return this.pdf ? this.pdf.numPages : 0;
            },
        },
        created() {
            this.$on('page-rendered', this.onPageRendered);
            this.$on('page-errored', this.onPageErrored);
            this.$on('pages-fetch', this.fetchPages);
        },
        render(h) {
            return h('div', [
                this.$scopedSlots.preview({
                    pages: this.pages,
                }),
                this.$scopedSlots.document({
                    pages: this.pages,
                }),
                this.$scopedSlots.toolbar({
                    pages: this.pages,
                })
            ]);
        },
        methods: {
            fetchPages(currentPage = 1) {
                console.log('Fetch page', currentPage)
                if (!this.pdf)
                    return;

                if (this.pageCount > 0 && this.pages.length === this.pageCount)
                    return;

                const startIndex = this.pages.length;
                if (this.cursor > startIndex)
                    return;

                const startPage = startIndex + 1;
                const endPage = Math.min(Math.max(currentPage, startIndex + BUFFER_LENGTH), this.pageCount);
                this.cursor = endPage;

                console.log(`Fetching pages ${startPage} to ${endPage}`);
                this.getPages(this.pdf, startPage, endPage).then((pages) => {
                    const deleteCount = 0;
                    this.pages.splice(startIndex, deleteCount, ...pages);
                    return this.pages;
                }).catch((response) => {
                    this.$emit('document-errored', {text: 'Failed to retrieve pages', response});
                    console.log('Failed to retrieve pages', response);
                });
            },
            onPageRendered({text, page}) {
                console.log(text, page);
            },
            onPageErrored({text, response, page}) {
                console.log('Error!', text, response, page);
            },
            getDocument(url) {
                // Using import statement in this way allows Webpack
                // to treat pdf.js as an async dependency so we can
                // avoid adding it to one of the main bundles
                const pdfjsPromise = import('pdfjs-dist');
                return pdfjsPromise.then(pdfjs => pdfjs.getDocument(url).promise);
            },
            getPages(pdf, first, last) {
                const allPages = range(first, last+1).map(number => pdf.getPage(number));
                return Promise.all(allPages);
            },
            getDefaults() {
                return {
                    pages: [],
                    cursor: 0,
                };
            }
        },
        watch: {
            url: {
                handler(url) {
                    this.getDocument(url).then(pdf => (this.pdf = pdf)).catch(response => {
                        this.$emit('document-errored', {text: 'Failed to retrieve PDF', response});
                        console.log('Failed to retrieve PDF', response);
                    });
                },
                immediate: true,
            },
            pdf(pdf, oldPdf) {
                if (!pdf)
                    return;

                if (oldPdf)
                    Object.assign(this, this.getDefaults());

                this.$emit('page-count', this.pageCount);
                this.fetchPages();
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/pdfViewer/PDFData.vue